import Content from './content';

export default function SessionLogs() {
  return (
    <div>
      <Content />
    </div>
  );
}
